export default {
  showFlashMessage(state, payload) {
    console.log(payload)
    state.message.type = payload.type
    state.message.body = payload.body
    state.message.show = true
    setTimeout(() => {
      state.message.show = false
    }, 2000)
  },
  hideFlashMessage(state) {
    state.message.show = false
  },
  hideMenu(state) {
    state.showMenu = false
  },
  toggleShowMenu(state) {
    state.showMenu = !state.showMenu
  },
  toggleShowSidebar(state) {
    state.showSidebar = !state.showSidebar
  },
  hideSideBar(state) {
    state.showSidebar = false
  },
  setUser(state, userPayload) {
    state.user = userPayload
  },
  removeUser(state) {
    state.user = {
      id: null,
      name: null,
      email: null,
      gravatar: null,
      role: null
    }
  },
  toggleCart(state) {
    console.log('toggle cart')
    state.showCart = !state.showCart
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js